import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("polyline", {
  points: "3,20 3,12 13,12 13,20 "
}), ___EmotionJSX("polyline", {
  points: "20,20 20,12 18.1,13.9 "
}), ___EmotionJSX("polyline", {
  points: "13,4 13,12 3,12 3,4 "
}));
export default SVG;